import { useFpB2bCartCalculate } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-calculate'
import { OrderDetail } from '@cart-ui/OrderDetail/OrderDetail'
import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Divider } from '@pets-ui/Divider/Divider'
import { CartOutlined } from '@pets-ui/icons'
import { ResponsiveDialog } from '@pets-ui/ResponsiveDialog/ResponsiveDialog'
import { useCart } from '../CartProvider/CartProvider'

export const DIALOG_ORDER_DETAIL = 'DIALOG_ORDER_DETAIL'

export interface DialogOrderDetailProps {
  handleCheckout: () => void
  actionButtonText?: string
}

export const DialogOrderDetail = () => {
  const { open, closeDialog, handleCheckout, actionButtonText } = useDialog<DialogOrderDetailProps>(DIALOG_ORDER_DETAIL)
  const { campaignId, currency, campaignCodeFromUrl, countryCode, platform } = useCart()
  const { calculateResult, calculateValue } = useFpB2bCartCalculate(campaignId, campaignCodeFromUrl, platform)

  return (
    <ResponsiveDialog
      open={open}
      onClose={closeDialog}
      fullWidth
    >
      <DialogHeader title="明細" onClose={closeDialog} />
      <OrderDetail
        discountItems={calculateResult?.discount_items || []}
        shippingTotal={calculateResult?.shipping_total ?? 0}
        total={calculateResult?.total ?? 0}
        subtotal={calculateResult?.subtotal ?? 0}
        subtotalAfterDiscount={calculateResult?.total_without_addon_v2 ?? 0}
        tax={calculateResult?.tax ?? 0}
        currency={currency || 'TWD'}
        countryCode={countryCode}
        rewardPoints={calculateValue.reward_point ?? 0}
        addonV2Total={calculateResult?.addon_v2_total ?? 0}
        addonV2TotalBeforeDiscount={calculateResult?.addon_v2_total_before_discount ?? 0}
      />
      <Divider />
      <DialogActions>
        <Button onClick={handleCheckout} startIcon={<CartOutlined />}>
          {actionButtonText || '前往結帳'}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
